import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import OpenSeadragon from "openseadragon";

const DZIs = ({ imgUrl }) => {
  const [open, setOpen] = useState(false);
  const viewerRef = useRef(null);

  const handleOpen = () => setOpen(!open);

  // Initialize OpenSeadragon when the modal is open and DOM is loaded
  useEffect(() => {
    if (open && viewerRef.current && imgUrl) {
      const viewer = OpenSeadragon({
        id: viewerRef.current.id,
        tileSources: imgUrl, // This should be a valid DZI URL or image URL
        showNavigator: true, // Optional: display a mini-map
        showZoomControl: true, // Optional: display zoom controls
      });

      return () => {
        viewer.destroy();
      };
    }
  }, [open, imgUrl]); // Re-run when modal opens or imgUrl changes

  return (
    <>
      <div className="btns flex gap-2">
        <Button onClick={handleOpen} variant="gradient">
          OpenSeaDragon
        </Button>
        
        {/* Zoomify button (no functionality) */}
        <Button variant="gradient" disabled>
          Zoomify (Disabled)
        </Button>
      </div>

      {/* OpenSeadragon Modal */}
      <Dialog open={open} handler={handleOpen} className="bg-black/60 text-white">
        <DialogHeader>OpenSeaDragon Viewer</DialogHeader>

        <DialogBody>
          {/* OpenSeadragon viewer container */}
          <div
            ref={viewerRef}
            id="openseadragon-viewer"
            style={{ width: "100%", height: "500px" }} // Ensure this has a fixed height
          />
        </DialogBody>

        <DialogFooter>
          <Button
            variant="text"
            color="red"
            onClick={handleOpen}
            className="mr-1"
          >
            <span>Cancel</span>
          </Button>
          <Button variant="gradient" color="green" onClick={handleOpen}>
            <span>Confirm</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default DZIs;
